/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CoolingRegimeGenusRequestBuilderNavigationMetadata, CoolingRegimeGenusRequestBuilderRequestsMetadata, type CoolingRegimeGenusRequestBuilder } from './coolingRegimeGenus/index.js';
// @ts-ignore
import { CoolingRegimePrioritiesRequestBuilderNavigationMetadata, CoolingRegimePrioritiesRequestBuilderRequestsMetadata, type CoolingRegimePrioritiesRequestBuilder } from './coolingRegimePriorities/index.js';
// @ts-ignore
import { CoolingRegimeProductGroupRequestBuilderNavigationMetadata, CoolingRegimeProductGroupRequestBuilderRequestsMetadata, type CoolingRegimeProductGroupRequestBuilder } from './coolingRegimeProductGroup/index.js';
// @ts-ignore
import { CoolingRegimeProductsRequestBuilderNavigationMetadata, CoolingRegimeProductsRequestBuilderRequestsMetadata, type CoolingRegimeProductsRequestBuilder } from './coolingRegimeProducts/index.js';
// @ts-ignore
import { CoolingRegimeTemperaturesRequestBuilderNavigationMetadata, CoolingRegimeTemperaturesRequestBuilderRequestsMetadata, type CoolingRegimeTemperaturesRequestBuilder } from './coolingRegimeTemperatures/index.js';
// @ts-ignore
import { CropsRequestBuilderNavigationMetadata, CropsRequestBuilderRequestsMetadata, type CropsRequestBuilder } from './crops/index.js';
// @ts-ignore
import { FeaturesRequestBuilderNavigationMetadata, FeaturesRequestBuilderRequestsMetadata, type FeaturesRequestBuilder } from './features/index.js';
// @ts-ignore
import { GeneraRequestBuilderNavigationMetadata, GeneraRequestBuilderRequestsMetadata, type GeneraRequestBuilder } from './genera/index.js';
// @ts-ignore
import { ProductAdministrationsRequestBuilderRequestsMetadata, type ProductAdministrationsRequestBuilder } from './productAdministrations/index.js';
// @ts-ignore
import { ProductGroupsRequestBuilderNavigationMetadata, ProductGroupsRequestBuilderRequestsMetadata, type ProductGroupsRequestBuilder } from './productGroups/index.js';
// @ts-ignore
import { ProductsRequestBuilderNavigationMetadata, ProductsRequestBuilderRequestsMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { RegulatoryCharacteristicsRequestBuilderNavigationMetadata, type RegulatoryCharacteristicsRequestBuilder } from './regulatoryCharacteristics/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}
 */
export interface VWithVersionRequestBuilder extends BaseRequestBuilder<VWithVersionRequestBuilder> {
    /**
     * The CoolingRegimeGenus property
     */
    get coolingRegimeGenus(): CoolingRegimeGenusRequestBuilder;
    /**
     * The CoolingRegimePriorities property
     */
    get coolingRegimePriorities(): CoolingRegimePrioritiesRequestBuilder;
    /**
     * The CoolingRegimeProductGroup property
     */
    get coolingRegimeProductGroup(): CoolingRegimeProductGroupRequestBuilder;
    /**
     * The CoolingRegimeProducts property
     */
    get coolingRegimeProducts(): CoolingRegimeProductsRequestBuilder;
    /**
     * The CoolingRegimeTemperatures property
     */
    get coolingRegimeTemperatures(): CoolingRegimeTemperaturesRequestBuilder;
    /**
     * The Crops property
     */
    get crops(): CropsRequestBuilder;
    /**
     * The Features property
     */
    get features(): FeaturesRequestBuilder;
    /**
     * The Genera property
     */
    get genera(): GeneraRequestBuilder;
    /**
     * The ProductAdministrations property
     */
    get productAdministrations(): ProductAdministrationsRequestBuilder;
    /**
     * The ProductGroups property
     */
    get productGroups(): ProductGroupsRequestBuilder;
    /**
     * The Products property
     */
    get products(): ProductsRequestBuilder;
    /**
     * The RegulatoryCharacteristics property
     */
    get regulatoryCharacteristics(): RegulatoryCharacteristicsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const VWithVersionRequestBuilderUriTemplate = "{+baseurl}/api/v{version}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VWithVersionRequestBuilderNavigationMetadata: Record<Exclude<keyof VWithVersionRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    coolingRegimeGenus: {
        requestsMetadata: CoolingRegimeGenusRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeGenusRequestBuilderNavigationMetadata,
    },
    coolingRegimePriorities: {
        requestsMetadata: CoolingRegimePrioritiesRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimePrioritiesRequestBuilderNavigationMetadata,
    },
    coolingRegimeProductGroup: {
        requestsMetadata: CoolingRegimeProductGroupRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeProductGroupRequestBuilderNavigationMetadata,
    },
    coolingRegimeProducts: {
        requestsMetadata: CoolingRegimeProductsRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeProductsRequestBuilderNavigationMetadata,
    },
    coolingRegimeTemperatures: {
        requestsMetadata: CoolingRegimeTemperaturesRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeTemperaturesRequestBuilderNavigationMetadata,
    },
    crops: {
        requestsMetadata: CropsRequestBuilderRequestsMetadata,
        navigationMetadata: CropsRequestBuilderNavigationMetadata,
    },
    features: {
        requestsMetadata: FeaturesRequestBuilderRequestsMetadata,
        navigationMetadata: FeaturesRequestBuilderNavigationMetadata,
    },
    genera: {
        requestsMetadata: GeneraRequestBuilderRequestsMetadata,
        navigationMetadata: GeneraRequestBuilderNavigationMetadata,
    },
    productAdministrations: {
        requestsMetadata: ProductAdministrationsRequestBuilderRequestsMetadata,
    },
    productGroups: {
        requestsMetadata: ProductGroupsRequestBuilderRequestsMetadata,
        navigationMetadata: ProductGroupsRequestBuilderNavigationMetadata,
    },
    products: {
        requestsMetadata: ProductsRequestBuilderRequestsMetadata,
        navigationMetadata: ProductsRequestBuilderNavigationMetadata,
    },
    regulatoryCharacteristics: {
        navigationMetadata: RegulatoryCharacteristicsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
